import { Component } from '@angular/core';

@Component({
  selector: 'app-separator',
  standalone: true,
  imports: [],
  templateUrl: './separator.component.html',
  styleUrl: './separator.component.scss'
})
export class SeparatorComponent {

}
